export enum FileTypes {
  Pdf = 'application/pdf',
  Png = 'image/png',
  Jpeg = 'image/jpeg',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Xls = 'application/vnd.ms-excel',
  Docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  Doc = 'application/msword',
  Pptx = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  Ppt = 'application/vnd.ms-powerpoint',
  Json = 'application/json',
}
